/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-email-address',
  templateUrl: './email-address.component.html',
  styleUrls: ['./email-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailAddressComponent {
  @Input() email!: FormControl<string>;

  constructor() {}
}
